<form class="w-100" [formGroup]="rangeForm">
    <input type="datetime-local" lang="ru" formControlName="startDate" [max]="maxDate" data-testid="common-date-range-start-date-input"/>
    <span>&ndash;</span>
    <input lang="ru" type="datetime-local" formControlName="endDate" [min]="rangeForm.get('startDate')?.value || ''"
           [max]="maxDate" data-testid="common-date-range-end-date-input"/>
</form>


